import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import {
    selectLoaded,
    selectLoading,
    selectSaved,
    selectSaving,
    selectPasswordSaving,
    selectPasswordSaved,
    selectPasswordError,
    selectProfile,
} from '../selectors/profile.selector';
import { profileActions } from '../actions/profile.actions';
import { ProfileValue, PasswordValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class ProfileFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);
    readonly profile$ = this.store.select(selectProfile);
    readonly profileNonNullable$ = this.store.select(selectProfile).pipe(filter((profile) => profile !== null));

    readonly profile = this.store.selectSignal(selectProfile);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly passwordSaving = this.store.selectSignal(selectPasswordSaving);
    readonly passwordSaved = this.store.selectSignal(selectPasswordSaved);
    readonly passwordError = this.store.selectSignal(selectPasswordError);

    getProfile(): void {
        this.store.dispatch(profileActions.getProfile());
    }

    updateProfile(value: ProfileValue): void {
        this.store.dispatch(profileActions.updateProfile({ value }));
    }

    changePassword(value: PasswordValue): void {
        this.store.dispatch(profileActions.changePassword({ value }));
    }

    clear(): void {
        this.store.dispatch(profileActions.clear());
    }
}
